import { useState } from "react";
import { useData } from "../../context/DataContext";
import { Card, CardHead, Btn, NativeSelect, TableWrap, Th, Td, Pill, EmptyState, IconBtn } from "../kit";
import { fmtINR, monthKey, monthLabel } from "../../lib/finance";
import { toast } from "sonner";
import { Trash2, Download, Upload } from "lucide-react";

export default function Ledger({ onExport, onImport }) {
  const { entries, saveEntries } = useData();
  const [month, setMonth] = useState("all");
  const [type, setType] = useState("all");

  const months = Array.from(new Set(entries.map((e) => monthKey(e.date)))).sort().reverse();
  let rows = entries.slice().sort((a, b) => b.date.localeCompare(a.date));
  if (month !== "all") rows = rows.filter((e) => monthKey(e.date) === month);
  if (type !== "all") rows = rows.filter((e) => e.type === type);

  const del = async (id) => { await saveEntries(entries.filter((e) => e.id !== id)); toast.success("Entry deleted"); };

  return (
    <Card>
      <CardHead title="All entries" subtitle="Your complete master ledger" right={
        <div className="hidden sm:flex gap-2">
          <Btn variant="outline" onClick={onExport} data-testid="ledger-export-button"><Download className="h-4 w-4" /> Export</Btn>
          <Btn variant="outline" onClick={onImport}><Upload className="h-4 w-4" /> Import</Btn>
        </div>
      } />
      <div className="flex flex-wrap gap-2 px-5 mt-4">
        <NativeSelect value={month} onChange={(e) => setMonth(e.target.value)} className="!w-auto">
          <option value="all">All months</option>
          {months.map((k) => <option key={k} value={k}>{monthLabel(k)}</option>)}
        </NativeSelect>
        <NativeSelect value={type} onChange={(e) => setType(e.target.value)} className="!w-auto">
          <option value="all">All types</option>
          <option value="income">Income only</option>
          <option value="expense">Expense only</option>
        </NativeSelect>
        <div className="sm:hidden flex gap-2 ml-auto">
          <Btn variant="outline" onClick={onExport} data-testid="ledger-export-button-mobile"><Download className="h-4 w-4" /></Btn>
          <Btn variant="outline" onClick={onImport}><Upload className="h-4 w-4" /></Btn>
        </div>
      </div>
      <div className="mt-4">
        {rows.length === 0 ? <EmptyState>No entries for this filter.</EmptyState> : (
          <TableWrap>
            <thead><tr><Th>Date</Th><Th>Category</Th><Th>Description</Th><Th className="text-right">Amount</Th><Th></Th></tr></thead>
            <tbody>
              {rows.map((e) => (
                <tr key={e.id} className="hover:bg-slate-50">
                  <Td className="text-slate-500">{e.date}</Td>
                  <Td><Pill tone={e.type === "income" ? "income" : "expense"}>{e.category}</Pill></Td>
                  <Td>{e.description}</Td>
                  <Td className={`text-right tnum font-semibold ${e.type === "income" ? "text-emerald-600" : "text-rose-600"}`}>{e.type === "income" ? "+" : "-"}{fmtINR(e.amount)}</Td>
                  <Td><IconBtn title="Delete" onClick={() => del(e.id)} className="hover:text-rose-600"><Trash2 className="h-4 w-4" /></IconBtn></Td>
                </tr>
              ))}
            </tbody>
          </TableWrap>
        )}
      </div>
      <div className="h-4" />
    </Card>
  );
}
